import { _ } from "~/i18n";
import { node } from "~/util/dom";

interface ICreateInput {
	text?: string;
	bold?: boolean;
	placeholder?: string;
	count?: number;
	onChange?: (value: string) => void;
}

// vytvorit poznamku
export function createMyMapsInput({
	text = "",
	bold = false,
	placeholder = "",
	count = 0,
	onChange = () => {},
}: ICreateInput) {
	const container = node("div", { className: "mymaps-input" });
	const input = node("input", { className: "mymaps-input__input", type: "text", value: text, placeholder });
	const countLine = node("div", { className: "mymaps-input__countLine" });
	const countLineRest = node("span", { className: "mymaps-input__countLineRest" });

	container.append(input);
	countLine.append(countLineRest);
	bold && input.classList.add("bold");
	input.addEventListener("input", event => {
		onChange((event.target as HTMLInputElement).value);
	});

	function updateRest() {
		const curLen = input.value.length;
		const restCount = count - input.value.length;

		countLineRest.innerHTML = _("detail.content.review.numOfChar", { chars: restCount });

		if (curLen === 0) {
			countLine.classList.remove("visible");
		} else {
			countLine.classList.add("visible");
		}
	}

	if (count > 0) {
		input.maxLength = count;
		container.append(countLine);
		input.addEventListener("input", () => {
			updateRest();
			onChange(input.value);
		});
		updateRest();

		if (text) {
			countLine.classList.add("visible");
		}
	}

	return {
		container,
		input,
	};
}
